<template>
<!-- FINAL ICARE -->
  <form @submit.prevent>
     <CModal
        :title.sync="title" 
        color="info"
        :closeOnBackdrop ="false"
        :show.sync="show">
        <CRow>
          <CCol>
            <CInput v-model="form.covenant_certificate"  label="Covenant Certificate No"   />
            <CInput v-model="form.covenant_date"  label="Covenant Date" type="date"  />
          </CCol> 
          </CRow>
       
        <template #footer>
        <CButton @click="show = false" color="danger">Cancel</CButton>
        <CButton  v-if="mode === 'create'" type="submit" v-on:click.prevent="create()"  variant="outline" color="info">Create</CButton>
        <CButton  v-if="mode === 'edit'" type="submit" v-on:click.prevent="update(form.uuid)"  variant="outline" color="info">Update</CButton>
     
        </template>
    </CModal>
  </form>
</template>
<script>
import EventBus from '@/eventBus';

import member from '@/services/member';
import satelite from '@/services/satelitechurch'
import icare from '@/services/icare'

import moment from 'moment'

export default {
name: 'covenantmodal',
  data () {
    return {
    show: false,
    title: 'Default Title',
    mode: '',
    form:{
      uuid:'',
      covenant_certificate:'',
      covenant_date:'',
    },
    }
  },

  mounted (){
     
   },
  
  created () {
    var self = this; 
      EventBus.$on('OPEN_MODAL_COVENANT', (params) => {
      if(params.data){
      member.getCovenant(params.data)
      .then(res => {
      self.show = true;
      self.title = params.title;
      self.mode = params.mode;
      self.form.uuid = params.data;
      self.form.covenant_certificate = res.data.covenant_certificate;
      self.form.covenant_date = res.data.covenant_date;
       }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }else{
        self.show = true;
        self.title = params.title;
        self.mode = params.mode;
        self.form.uuid = "";
        self.form.covenant_certificate = "";
        self.form.covenant_date = "";
      }
 
    });
    
  },
  methods: {
    open () {
      this.show = true;
    },
    close () {
      this.show = false;
    },
    update(id){
      this.show = false;
      if(this.form.covenant_date != null){
          this.form.covenant_date = moment(this.form.covenant_date).format ('DD/MM/YYYY')
      } else{
         this.form.covenant_date = ''
      }
      member.updateCovenant(id, this.form)
      .then(res => {
        EventBus.$emit('PAGE_UPDATE', true)
        var params = {title: 'Success', mode:'success', data:res.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },
  
   
  }
}
</script>

<style>

</style>